import React from 'react';

import Settings from '../Settings/Settings';

function Header() {
  return (
    <header>
      <h1>Word Game</h1>
      <Settings />
    </header>
  );
}

export default Header;
